import React from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';

import './CalendarCheckout.css';
import CalendarPage from '../CalendarPage/CalendarPage';
import { PROCESSOR_OPT_STATUS } from '../../constants/processors';

import CheckoutSuccess from './CheckoutSuccess/CheckoutSuccess';
import NotInRegion from './NotInRegion/NotInRegion';
import PaymentFailed from './PaymentFailed/PaymentFailed';
import PaymentError from './PaymentError/PaymentError';


function CalendarCheckout(props) {
  const { location } = props;
  const queryParams = qs.parse(props.location.search, { ignoreQueryPrefix: true });
  const { opStatus, shippingAnchorId } = queryParams;
  const renderContent = () => {
    switch (opStatus) {
      case PROCESSOR_OPT_STATUS.SUCCESS:
        return (
          <CheckoutSuccess anchorId={shippingAnchorId} location={location} />
        );
      case PROCESSOR_OPT_STATUS.FAILED:
        return <PaymentFailed anchorId={shippingAnchorId} />;
      case PROCESSOR_OPT_STATUS.NOT_IN_REGION:
        return <NotInRegion anchorId={shippingAnchorId} />;
      case PROCESSOR_OPT_STATUS.ERROR:
        return <PaymentError anchorId={shippingAnchorId} />;
      default:
        return <div>Unexpected status</div>;
    }
  };

  return <CalendarPage>{renderContent()}</CalendarPage>;
}

CalendarCheckout.propTypes = { location: PropTypes.object.isRequired };

export default CalendarCheckout;
